export default {
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [TR]",
    homepageTitleGC: "SMART-TEAM-DEV-PORTAL",
    homepageTitleGES: "PORTAL",
    homepageIcon: {icopathGC: "gc/gcLogo", colorGC: "black|white", icopathGES: "gc/gesLogo", colorGES: "black|white"},
    programVersion: "Program sürümü: ",
    loremipsumdolor: "Müşteri çok önemli, müşteriyi müşteri takip edecek...",
    moredetailed: "Daha fazla detay",
    loadingdata: "Veri yükleniyor",
    savingdata: "Veri kaydediliyor",
    processing: "İşleme...",
    lookingUpDnsName: "DNS sunucusu adı arıyorum",
    finish: "Tamamlamak",
    error: "Hata",
    warning: "Uyarı",
    send: "Göndermek",
    sendMeCode: "Kodu bana gönder",
    changetheme: "Renk temasını değiştir",
    userpage: "Kullanıcı ayarları",
    online: "Çevrimiçi",
    offline: "Çevrimdışı",
    usrexit: "Dışarı çıkmak",
    usrlogin: "İçeri gel / telefon",
    fieldlogin: "Giriş yapmak",
    fieldpass: "Şifre",
    buttonlogin: "İçeri gel",
    buttonclose: "Kapalı",
    collapseExpand: "Büyütmek",
    buttonExpandWindow: "Pencereyi büyüt",
    buttonCollapseWindow: "Bir pencereyi simge durumuna küçült",
    authFormTitle: "Kullanıcı Yetki Formu",
    redirection: "Yönlendirme...",
    undo: "Geri al",
    redo: "Yinele",
    back: "Geri",
    forward: "İleri",
    copy: "Kopyala",
    paste: "Yapıştır",
    cut: "Kesmek",
    help: "Referans",
    homebuttontitle: "Ana sayfa",
    mainmenutitle: "Ana menü",
    preview: "Ön izleme",
    selectItems: "Öğeleri seçin",
    standartQuestion: "Standart soru",
    removeItems: "Bu öğeleri veritabanından kaldır",
    adminTools: "Yönetici araçları",
    replaceThumbnailPhotoInAD: "ActiveDirectory'deki görselin küçük resmini değiştirin",
    showRecordset: "Kayıt görüntüle",
    editRecordset: "Kayıt düzenle",
    createRecordset: "Kayıt oluştur",
    createCopyOfRecordset: "Kayıt kümesinin bir kopyasını oluşturma",
    removeRecordset: "Kayıt sil",
    removeRecordsetFromDatabase: "Veritabanından bir kaydı kalıcı olarak silme",
    restoreRemovedRecordset: "Kaldırılan kayıt kümesini geri yükleyin",
    setAsArchival: "Arşiv olarak Mark Recordset",
    unsetAsArchival: "Restore selected recordset from the archive",
    disableUser: "Kullanıcıyı Devre Dışı Bırak",
    enableUser: "Kullanıcıyı Etkinleştir",
    disableGroup: "Grubu Devre Dışı Bırak",
    enableGroup: "Grubu Etkinleştir",
    unlockUser: "Kullanıcının engelini kaldır",
    unbanUser: "Bir Kullanıcının Yasağını Kaldırma",
    replaceStatusToOnline: "Çevrimiçi durumu ayarla",
    replaceStatusToOffline: "Çevrimdışı durumunu ayarla",
    showUserActionsHistory: "Kullanıcı etkinliği geçmişini görüntüle",
    userAttributesWillBeChanged: "Için aşağıdaki özellikler değiştirilecek için Kullanıcı ",
    selectGroupMembers: "Grup Üyelerini Seçin",
    removeSelectedUserFromGroup: "Seçilen Kullanıcıyı Gruptan kaldır",
    showInstalledPrograms: "Yüklü programları göster",
    showInstalledPrinters: "Yüklü yazıcıları göster",
    showProcesses: "Çalışan işlemleri göster",
    getWindowsOfficeActivationStatus: "Windows ve Office etkinleştirme durumunu alın",
    activateWindowsOffice: "Windows ve Office'i etkinleştirin",
    ipConfigFlushDns: "DNS önbelleğini temizleyin",
    turnOffTheComputer: "Bilgisayarı kapat",
    getScreenshotFromRemoteComputer: "Masaüstü ekran görüntüsü",
    openInBrowser: "Tarayıcıda aç",
    sendBallunMessageToComp: "Kullanıcının bilgisayarına açılır mesaj gönder",
    sendMessageToUserEmail: "Mesajı E-postayla gönder",
    sendMessageToUserViber: "Viber'de bir mesaj gönderin",
    sendMessageToUserTelegram: "Telegram'a mesaj gönder",
    sendMessageToUserMattermost: "Mattermost'a mesaj gönder",
    // eslint-disable-next-line max-len
    srvbgAppWillRestart: "'ActiveDirectorySync' (syncADInterval) veya 'compareUsersPhoto' (syncPhotoInterval) veya 'clearOldUploads' hizmetlerinin başlangıç ​​periyodunun değiştirilmesi, ayarlar kaydedildikten sonra 'srvbg-app' programının yeniden başlatılmasına neden olacaktır!",
    srvbgSyslogWillRestart: "'SysLogServer' hizmetinin etkinleştirilmesi veya devre dışı bırakılması 'srvbg-syslog' programını yeniden başlatacaktır",
    portalAppWillRestart: "'clearOldUploads' hizmetinin başlangıç ​​periyodunun değiştirilmesi, ayarlar kaydedildikten sonra 'smartteamdev' programının yeniden başlatılmasına neden olacaktır!",
    srvbgHikWillRestart: "'SKUD-SERVER' ile senkronizasyon süresinin değiştirilmesi 'srvbg-skud' programını yeniden başlatacaktır",
    active: "Aktif olarak",
    notActive: "Aktif değil",
    enabled: "Dahil",
    disabled: "Kapalı",
    locked: "Engellendi",
    lockedEditDel: "Silinmeye ve değiştirilmeye karşı kilitlendi",
    unlocked: "Kilitli değil",
    adGroup: "Etki alanı grubu",
    fbaGroup: "Özel grup",
    adUser: "Etki alanı kullanıcısı",
    fbaUser: "Harici kullanıcı",
    guest: "Misafir",
    banned: "Yasaklandı",
    usermenu: [
      { key: "changelng", label: "Change Language" },
      { key: "changetheme", label: "Konuyu değiştir" },
      { key: "changecompact", label: "Kompakt arayüz" },
      { key: "about", label: "Hakkında" },
      { key: "exit", label: "Uygulamadan Çıkma" }
    ]
  },
  e: {
    pageNotfoundOrDenied: "Sayfa bulunamadı veya yeterli haklara sahip değilsiniz",
    accessDenied: "Erişim engellendi",
    userDontHaveAnougthRight: "Yeterli haklara sahip değilsiniz",
    dbDenied: "Veritabanı erişimi reddedildi",
    nullLoginOrPass: "Gerekli bağımsız değişkenler eksik - login & pass",
    userLoggedFailed: "Yetkilendirme Hatası",
    incorrectOldPassword: "Yanlış eski şifre",
    unknowErrorWhileReactElementsBuilding: "React bileşenlerini oluştururken bilinmeyen hata",
    exportError: "Dışa aktarma hatası",
    cantFindTableRowWithKey: "Içeren tablo satırını bulamıyorum anahtar = ",
    unknownError: "Bilinmeyen hata",
    somethingWrong: "Bir şeyler ters gitti",
    recIsNotFoundInDB: "Kayıt kümesi veritabanında bulunamadı",
    yandexMapsIsNotLoaded: "Yandex-haritalar modülü yüklenmedi. Belki yönetici tarafından kapatılır",
    fileNotFound: "Dosya bulunamadı",
    cryptoError1: "Verileri sunucudan deşifre etmek mümkün değildi. Yanlış Anahtar veya Başlatma Vektörü!"
  },
  w: {
    enterOnlyLoginBeforeSendCode: "Lütfen kodu almadan önce yalnızca kullanıcı adınızı veya telefon numaranızı girin",
    allowedFileTypes: "Yalnızca aşağıdaki dosya türlerini yükleyebilirsiniz: ",
    maxFileSizeError: "Dosya boyutu en fazla olmalıdır ",
    selectOnlyOneRow: "Yalnızca bir satır seçin",
    NotApplicableToThisTable: "Bu tablo için geçerli değil",
    nothingSelected: "Hiçbir şey seçilmedi",
    needToSelectMoreThanOne: "1'den fazla öğe seçilmelidir",
    incorrectDataFormat: "Geçersiz veri biçimi",
    nameFieldRequiredBeforeGenerateLogin: "Oturum açma bilgileri otomatik olarak oluşturulmadan önce 'Ad' alanı doldurulmalıdır!",
    loginFieldAlreadyFilled: "'Giriş' alanı zaten doldurulmuştur. Otomatik olarak yeni bir değer oluşturmadan önce değerleri silin",
    mailFieldAlreadyFilled: "'e-posta' alanı zaten doldurulmuştur. Otomatik olarak yeni bir değer oluşturmadan önce değerleri silin",
    passFieldAlreadyFilled: "'şifre' alanı zaten doldurulmuştur. Otomatik olarak yeni bir değer oluşturmadan önce değerleri silin",
    thisNameAlreadyExistInAD: "Bu kullanıcı adı zaten mevcut! Yeni bir değer girin",
    thisLoginAlreadyExistInAD: "Bu kullanıcı adı zaten mevcut! Yeni değer girin",
    userLoginAlreadyExist: "Bu Oturum Açma Adına / sAMAccountName'e sahip kullanıcı zaten mevcut",
    groupAlreadyExist: "Böyle bir grup zaten var",
    userNameAlreadyExist: "Bu Isme sahip kullanıcı zaten mevcut",
    cantRemoveTheLastRow: "Son satırı silemiyorum",
    errFields1: "Tüm alanlar düzgün şekilde doldurulmamış",
    serverReturnedEmptyArray: "Sunucu boş bir dizi döndürdü",
    passIsNull: "'Şifre' alanı boş",
    newPassIsNull: "'Yeni şifre' alanı boş",
    newPass2IsNull: "'Şifreyi tekrarla' alanı boş",
    passTooShort: "'Şifre' alanı çok kısa",
    newPassTooShort: "'Yeni şifre' alanı çok kısa (en az 6 karakter olmalıdır)",
    passMastHave: "Şifre harfler (büyük ve küçük harf), rakamlar ve en az bir işaret (- # $ ! @ &) içermelidir",
    passwordsMismatch: "Şifre eşleşmiyor",
    cantModifyADgroupUsers: "Bu uygulamada ActiveDirectory grup üyeliğini değiştiremezsiniz. 'Etki Alanı Grupları' veya 'Etki Alanı Kullanıcıları' uygulamasını kullanın",
    cantModifyLockedUser: "Korunan Kullanıcıları düzenleyemiyorum/silemiyorum. Bu kullanıcıları yalnızca devre dışı bırakabilir/etkinleştirebilir veya şifrelerini değiştirebilirsiniz",
    cantModifyADgroup: "Bu uygulamada ActiveDirectory gruplarını değiştiremez veya silemezsiniz",
    cantRemoveADuser: "Bu uygulamada ActiveDirectory kullanıcılarını silemezsiniz. Etki Alanı Denetleyicisindeki ActiveDirectory ek bileşenini kullanma",
    cantModifyLockedRecordset: "Korumalı giriş düzenlenemiyor / silinemiyor",
    recordsetDoesntExistInDB: "Bu Kayıt veritabanında mevcut değil",
    sameFileAlreadyExistInUploads: "'Uploads'de aynı adda bir dosya zaten mevcut",
    contragentAlreadyExist: "Veritabanında aynı ada ve TIN'ye sahip bir karşı taraf zaten mevcut",
    employeeAlreadyExist: "Veritabanında zaten bu tür verilere sahip bir çalışan var",
    recordsetAlreadyExist: "Bu tür kayıt kümesi veritabanında zaten mevcut",
    recordsetSimmilarAlreadyExist: "Saha değerlerinin veritabanındaki mevcut başka bir girişle çakışması için RecordSet'i değiştirdiniz!",
    recordsetAlreadyInRecycleBin: "Kayıt kümesi zaten Geri Dönüşüm Kutusu'nda",
    noSelectedrecordsetsInRecycleBin: "Silinen kayıt kümesi seçilmedi",
    recordsetAlreadyIsArchival: "RecordSet zaten arşiv gibi",
    recordseIsNotArchival: "RecordSet arşivde değil",
    copyingIsProhibited: "Verilerin kopyalanması yasaktır",
    notYetDeveloped: "Henüz gelişmedi..."
  },
  i: {
    codeHasBeenSent: "Kod gönderildi",
    userLoggedSuccess: "Başarıyla giriş yaptınız",
    successDeleted: "Başarıyla silindi",
    successUpdated: "Başarıyla güncellendi",
    successCreated: "Başarıyla oluşturuldu",
    successOperation: "Başarıyla tamamlandı",
    nothingHasChanged: "Hiçbir şey değişmedi",
    messageHasBeenSent: "Mesaj gönderildi",
    messageWillBeSentAfterSaveForm: "'Kaydet' düğmesine tıkladıktan sonra kullanıcılara mesaj gönderilecek",
    finish: "Tamamlamak"
  },
  q: {
    doYouWantRemoveTheseItems: "Bu Öğeleri kaldırmak istiyor musunuz?",
    doYouWantReplaceThumbnailPhoto: "Seçilen 00 kullanıcılar için ActiveDirectory'deki görsel küçük resimlerini değiştirmek mi istiyorsunuz?",
    doYouWantSwitchStatusToOnline: "Durumunuzu çevrimiçine geçirmek ister misiniz?",
    doYouWantSwitchStatusToOffline: "Durumunuzu çevrimdışına mı geçirmek istiyorsunuz?",
    doYouWantToCreateUser: "Yeni bir AD Kullanıcısı oluşturmak istiyor musunuz ",
    doYouWantDisableSelectedUser: "Seçilen kullanıcıyı ActiveDirectory'de devre dışı bırakmak istiyor musunuz?",
    doYouWantEnableSelectedUser: "Seçilen kullanıcıyı ActiveDirectory'de etkinleştirmek istiyor musunuz?",
    doYouWantDisableSelectedGroup: "Grubu devre dışı bırakmak istiyor musunuz ",
    doYouWantEnableSelectedGroup: "Grubu etkinleştirmek istiyor musunuz ",
    doYouWantUnlockSelectedUser: "Seçilen bir kullanıcının engellemesini kaldırmak istiyor musunuz (birçok kez yanlış şifre girdikten sonra)?",
    doYouWantToRemoveSelecctedUsersFromSelectedGroup: "Seçilen Kullanıcıları Gruptan kaldırmak istiyorsunuz",
    doYouWantAddUsersToGroup: "Bir Gruba kullanıcı eklemek istiyorsunuz",
    doYouWantRemoveUsersFromGroup: "Kullanıcıları Gruptan kaldırmak istiyorsunuz",
    doYouWantRemoveGroup: "Kullanıcı Grubunu silmek istiyor musunuz ",
    doYouWantRemoveUser: "Bir Kullanıcıyı silmek istiyor musunuz ",
    doYouWantRemoveThisRecordset: "Bu kayıt kümesini silmek istiyor musunuz?",
    doYouWantRemoveTheseRecordsets: "Bu kayıt kümelerini silmek istiyor musunuz?",
    doYouWantRemoveTheseRecordsetsFromDB: "Bu kayıt setlerini veritabanından silmek istiyor musunuz?",
    doYouWantRestoreTheseRecordsets: "Bu kayıtları geri yüklemek ister misiniz?",
    doYouWantMarkTheeseRecordsAsArchival: "Bu kayıtları arşiv olarak işaretlemek istiyor musunuz?",
    doYouWantRestoreTheeseRecordsFromArchival: "Bu kayıtları arşivden geri yüklemek istiyor musunuz?",
    gptForgetContext: "Yeni bir konuşma mı başlatacaksınız (geçerli konuşmanın içeriğini mi unuttunuz)?",
    resetAppSettings: "'appname' uygulama ayarları 'apps/appname/index.js' dosyasından varsayılana sıfırlansın mı?"
  },
  unit: {
    pcs: "adet",
    m: "m",
    m2: "m²",
    m3: "m³",
    mm: "mm",
    kg: "kg"
  },
  ag: {
    sideBarColumnsTitle: "Sütunlar",
    sideBarFiltersTitle: "Filtreler",
    autoWidthColumns: "Otomatik sütun genişliği",
    quickChart: "Hızlı grafik",
    online: "Çevrimiçi",
    onlinev: "Çevrimiçi (Kullanıcı doğrulandı)",
    offline: "Çevrimdışı",
    deprecated: "Eski veya bozuk",
    setQuickFilter: "Bu değere göre hızlı bir filtre ayarlayın",
    resetFilters: "Tüm filtreleri sıfırla",
    excelExport: "Excel'e aktar",
    jsonExport: "JSON'e aktar",
    dhcpDinamic: "DHCP dinamik",
    dhcpStatic: "DHCP statik",
    ovpn: "OVPN",
    ipsec: "IPSEC",
    vpn: "VPN",
    l2tp: "L2TP",
    pptp: "PPTP",
    device: "Cihaz",
    comp: "Bilgisayar / Dizüstü bilgisayar",
    phone: "Telefon",
    tablet: "Tablet",
    printer: "Yazıcı",
    mfu: "MFP",
    router: "Yönlendirici / Anahtar",
    registrator: "Kayıt memuru",
    camera: "Kamera",
    server: "Sunucu",
    unknown: "Bilinmeyen",
    group: "Grup",
    ungroup: "Grubu çöz",
    synology: "Synology DiskStation",
    windowsserver: "Windows sunucusu/bilgisayar",
    webserver: "Web sunucusu",
    otherserver: "Başka bir sunucu",
    connection: "Bağlantı",
    fsowin: "FSO-Windows",
    fsoweb: "FSO-WEB",
    portal: "Portal",
    webservice: "WEB-servisi",
    otheraction: "Diğer hareket",
    disabledUser: "Kullanıcı devre dışı bırakıldı",
    enabledUser: "Kullanıcı etkinleştirildi",
    deleteRow: "Sırayı sil",
    addRow: "Satır ekle"
  },
  gpt: {
    userDoesntHaveEnoughRightsToWorkWithGPT: "ChatGPT kullanarak bu tabloyu analiz etmek için yeterli hakınız yok",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "Ses komutlarını çalıştırmak için yeterli hakınız yok",
    thereAreNoDataForAnalysis: "Analiz için veri yok",
    incorrectRequest: "Yanlış istek",
    incorrectDatePeriod: "Bir talep oluşturmak için yanlış tarihler",
    speechRecognitionError: "Konuşma tanıma hatası",
    speechRecognitionNull: "Kaydedilmiş bir mesaj yok. Tanıyacak hiçbir şey yok",
    undefinedEmployee: "Hangi çalışanların söz konusu olduğunu belirlemek mümkün değildi",
    undefinedCommand: "Komut, izin verilen eylemler listesine dahil değildir. Bir ses asistanı çağırmadan önce izin verilen komutlar listesine göz atın",
    noAnswerFromChatGPT: "Chatgpt'ten cevap yok",
    ansWasCopiedToBuffer: "AI cevabı panoya kopyalanır",
    copyToBufferError: "Panoya kopyalarken bir hata vardı",
    voiceRecordingStart: "Mikrofondan sesin bir kaydı var",
    voiceRecordingStop: "Sesin kaydı durdu",
    micPermissionsError: "Cihazınızın mikrofonuna erişme hakkı yok",
    tooltip1: "ChatGPT Kullanarak Veri Analizi",
    tooltip2: "Ses komutunu çalıştırın",
    selectCompany: "Bir şirket seçin"
  },
  adusers: {
    title: "Etki Alanı Kullanıcıları",
    headers: [
      { key: "name", title: "Kullanıcı adı" },
      { key: "status", title: "Durum" },
      { key: "thumbnailPhoto", title: "Fotoğraf" },
      { key: "sAMAccountName", title: "Giriş yapmak", hidden: true },
      { key: "company", title: "Şirket" },
      { key: "groups", title: "Gruplar", hidden: true, visfor: ["admins", "headship"] },
      { key: "phones", title: "Telefonlar" },
      { key: "mail", title: "Email" },
      { key: "title", title: "İş unvanı" },
      { key: "manager", hidden: true, title: "Süpervizör" },
      { key: "description", title: "Tanım" },
      { key: "department", title: "Alt bölüm" },
      { key: "office", hidden: true, title: "Ofis" },
      { key: "lng", title: "Dil", hidden: true, visfor: ["admins", "headship"] },
      { key: "country", title: "Taraf", hidden: true, visfor: ["admins", "headship"] },
      { key: "region", title: "Bölge", hidden: true, visfor: ["admins", "headship"] },
      { key: "city", title: "Şehir", hidden: true, visfor: ["admins", "headship"] },
      { key: "street", title: "Adres", hidden: true, visfor: ["admins", "headship"] },
      { key: "distinguishedName", title: "Distinguished Name", hidden: true, visfor: ["admins"] },
      { key: "adNotes", title: "Notlar", hidden: true, visfor: ["admins", "headship"] },
      { key: "accountDisable", title: "Hesap Devre Dışı", hidden: true },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins", "headship"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] }
    ]
  },
  adusers_devices: {
    headers: [
      { key: "summarystatus", title: "Cihaz durumu" },
      { key: "devicetype", title: "Cihaz türü", hidden: true },
      { key: "connectiontype", title: "Bağlantı türü", hidden: true },
      { key: "status", title: "Durum", hidden: true },
      { key: "devicename", title: "Cihaz adı" },
      { key: "internalip", title: "Dahili IP" },
      { key: "externalip", title: "Harici IP", hidden: true },
      { key: "place", title: "Konum" },
      { key: "caption", title: "Tanım" },
      { key: "lastOnlineTime", title: "Ne zaman çevrimiçiydi" },
      { key: "login", title: "Kullanıcı girişi", hidden: true }
    ]
  },
  adgroups: {
    title: "Etki Alanı Grupları",
    headers: [
      { key: "sAMAccountName", title: "Grup ismi"},
      { key: "memberOf", title: "Diğer grupların üyesi" },
      { key: "description", title: "Tanım" }
    ]
  },
  addevices: {
    title: "Etki Alanı Bilgisayarları",
    headers: [
      { key: "status", title: "Durum" },
      { key: "name", title: "Cihaz adı" },
      { key: "description", title: "Tanım" },
      { key: "operatingSystem", title: "işletim sistemi" },
      { key: "sAMAccountName", title: "Kullanıcı Girişi", hidden: true },
      { key: "userName", title: "Kullanıcı adı" },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] },
      { key: "distinguishedName", title: "distinguishedName", hidden: true, visfor: ["admins"] }
    ]
  },
  mikrotik: {
    title: "Yönlendiricilerden Gelen Cihazlar",
    headers: [
      { key: "summarystatus", title: "Cihaz durumu" },
      { key: "devicetype", title: "Cihaz tipi", hidden: true },
      { key: "connectiontype", title: "Bağlantı türü", hidden: true },
      { key: "status", title: "Durum", hidden: true },
      { key: "devicename", title: "Cihaz adı" },
      { key: "login", title: "Kullanıcı Girişi" },
      { key: "userName", title: "Kullanıcı adı" },
      { key: "internalip", title: "İç mekan IP" },
      { key: "externalip", title: "Harici IP", hidden: true },
      { key: "place", title: "Konum" },
      { key: "caption", title: "Tanım", hidden: true },
      { key: "mac", title: "MAC-adres", hidden: true, visfor: ["admins"] }
    ]
  },
  acsreporter: {
    title: "ACS Reporter",
    history: {
      forgetThisConversation: "Bu konuşmayı unut",
      headers: [
        {key: "strDate", title: "Tarih"},
        {key: "message", title: "Konuşma başlangıcı"}
      ]
    }
  },
  syslogserver: {
    title: "Sistem Günlüğü Sunucusu Olayları",
    headers: [
      { key: "login", title: "Kullanıcı Girişi" },
      { key: "action", title: "Etkinlik" },
      { key: "strDate", title: "Tarih Saat" },
      { key: "syslogClientType", title: "Sunucu tipi" },
      { key: "actionType", title: "Eylem Türü" },
      { key: "serverName", title: "Sunucu adı", hidden: true },
      { key: "name", title: "Kullanıcı adı" },
      { key: "devicetype", title: "Cihaz tipi", hidden: true },
      { key: "devicename", title: "Cihaz adı" },
      { key: "connectiontype", title: "Bağlantı türü", hidden: true, visfor: ["admins", "headship"] },
      { key: "internalip", title: "İç mekan IP", hidden: true },
      { key: "externalip", title: "Harici IP", hidden: true, visfor: ["admins", "headship"] },
      { key: "place", title: "Konum" }
    ],
    history: {
      forgetThisConversation: "Bu konuşmayı unut",
      headers: [
        {key: "strDate", title: "Tarih"},
        {key: "message", title: "Konuşma başlangıcı"}
      ]
    }
  },
  selectUsersGrid: {
    title: "Kullanıcı seçimi",
    headers: [
      { key: "name", title: "Kullanıcı adı" },
      { key: "sAMAccountName", title: "Kullanıcı Girişi" },
      { key: "title", title: "İş unvanı" },
      { key: "department", title: "Alt bölüm" }
    ]
  },
  usersettings: {
    title: "Mevcut kullanıcı ayarları"
  },
  programsettings: {
    knownIPAddresses: {
      headers: [
        {key: "ip", title: "Harici IP"},
        {key: "internalip", title: "Dahili IP"},
        {key: "address", title: "Konum"}
      ]
    },
    allowedExternalAccess: {
      headers: [
        {key: "ip", title: "Harici/Dahili IP"},
        {key: "comment", title: "Yorum"}
      ]
    },
    knownVPNaddresses: {
      headers: [{key: "VPNinternalip", title: "VPN bağlantılarının dahili IP adresleri"}]
    },
    ADuserTemplates: {
      headers: [
        {key: "key", title: "key"},
        {key: "title_en", title: "İngilizce şablon adı"},
        {key: "title_ru", title: "Rusça şablon adı"},
        {key: "title_tr", title: "Türkçe şablon adı"},
        {key: "groups", title: "Gruplar"},
        {key: "jobTitle", title: "İş unvanı"},
        {key: "department", title: "Alt bölüm"},
        {key: "description", title: "Tanım"},
        {key: "company", title: "Şirket"},
        {key: "office", title: "Ofis"},
        {key: "manager", title: "Süpervizör"}
      ]
    },
    mikrotikDevices: {
      headers: [
        {key: "active", title: "Aktif"},
        {key: "host", title: "Ana makine adı"},
        {key: "version", title: "Mikrotik işletim sistemi sürümü"},
        {key: "username", title: "Kullanıcı"},
        {key: "password", title: "Şifre"}
      ]
    },
    sysLogServer_knownFileServers: {
      headers: [
        {key: "internalip", title: "Yerel IP adresi"},
        {key: "serverName", title: "Sunucu adı"},
        {key: "serverPath", title: "Klasörün başlangıç ​​yolu"}
      ]
    },
    sysLogServer_knownExternalUsers: {
      headers: [
        {key: "login", title: "VPN bağlantısında oturum açın"},
        {key: "name", title: "Ekran adı"}
      ]
    },
    sysLogServer_ignoreFiles: {
      headers: [
        {key: "filemask", title: "Dosya adı maskesi"}
      ]
    },
    sysLogServer_ignoreActions: {
      headers: [
        {key: "actionmask", title: "Etkinlik Maskesi"}
      ]
    },
    appRoles: {
      headers: [
        {key: "role", title: "Rol"},
        {key: "enabled", title: "Aktif"},
        {key: "title", title: "İsim"},
        {key: "caption", title: "Tanım"},
        {key: "groups", title: "Gruplar"},
        {key: "users", title: "Kullanıcılar"}
      ],
      grheaders: [
        {key: "group", title: "Grup"},
        {key: "expired", title: "Süresi doluyor"}
      ],
      uheaders: [
        {key: "user", title: "Kullanıcı"},
        {key: "expired", title: "Süresi doluyor"}
      ]
    },
    appDatabases: {
      headers: [
        {key: "name", title: "Veri tabanı"},
        {key: "allow", title: "Varsayılan olarak izin veriliyor"},
        {key: "select", title: "Varsayılan olarak kullanılabilir veritabanı alanları"},
        {key: "filters", title: "Varsayılan filtreler"},
        {key: "roles", title: "Belirli roller için istisnalar"}
      ],
      rheaders: [
        {key: "role", title: "Rol"},
        {key: "allow", title: "Neye izin veriliyor"},
        {key: "select", title: "Kullanılabilir veritabanı alanları"},
        {key: "filters", title: "Filtreler"}
      ]
    },
    emailSMTP: {
      headers: [
        {key: "name", title: "Ad (posta kutusu adresi)"},
        {key: "enabled", title: "Etkinleştirilmiş"},
        {key: "server", title: "Sunucu"},
        {key: "port", title: "Liman"},
        {key: "user", title: "Kullanıcı"},
        {key: "pass", title: "Şifre"},
        {key: "rules", title: "Tüzük"}
      ],
      rulesHeaders: [
        {key: "useForRecipients", title: "Alıcılar için kullanın"},
        {key: "useIfSubject", title: "Konu şunları içeriyorsa kullanın"}
      ]
    },
    emailIMAP: {
      headers: [
        {key: "name", title: "Ad (posta kutusu adresi)"},
        {key: "autoCheckEnable", title: "Otomatik kontrolü etkinleştir"},
        {key: "server", title: "Sunucu"},
        {key: "port", title: "Liman"},
        {key: "user", title: "Kullanıcı"},
        {key: "pass", title: "Şifre"},
        {key: "theOldestMailDate", title: "Bu tarihe kadar postaları kontrol edin (en eski tarih)"},
        {key: "rules", title: "Tüzük"}
      ],
      rulesHeaders: [
        {key: "subject", title: "Konu şunları içeriyor"},
        {key: "from", title: "Gönderen"},
        {key: "body", title: "Mektubun gövdesi şunları içerir"},
        {key: "hasAttachments", title: "Ekler var"},
        {key: "serverAction", title: "ServerAction"}
      ]
    }
  },
  chatgpt: {
    history: {
      forgetThisConversation: "Bu konuşmayı unut",
      headers: [
        {key: "strDate", title: "Tarih"},
        {key: "message", title: "Sohbet başlatmak"}
      ]
    }
  },
  fbagroups: {
    title: "Portal kullanıcı grupları",
    headers: [
      {key: "status", title: "Grup türü"},
      {key: "locked", title: "Engellendi", hidden: true},
      {key: "enabled", title: "Aktif/Hayır", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "group", title: "Grup"},
      {key: "description", title: "Tanım"},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]}
    ]
  },
  selectFBAUsersGrid: {
    title: "Kullanıcı seçimi",
    headers: [
      {key: "login", title: "Kullanıcı girişi"},
      {key: "name_ru", title: "Rusça isim"},
      {key: "name_en", title: "İngilizce adı"}
    ]
  },
  fbausers: {
    title: "Portal kullanıcıları",
    headers: [
      {key: "status", title: "Kullanıcı türü"},
      {key: "locked", title: "Engellendi", hidden: true},
      {key: "banned", title: "Yasak", hidden: true},
      {key: "enabled", title: "Etkin/Devre Dışı", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "thumbnailPhoto", title: "Fotoğraf"},
      {key: "name", title: "Kullanıcı adı"},
      {key: "name_ru", title: "Rusça isim", hidden: true},
      {key: "name_en", title: "İngilizce adı", hidden: true},
      {key: "login", title: "Giriş yapmak", hidden: true},
      {key: "company", title: "Şirket"},
      {key: "phones", title: "Telefonlar"},
      {key: "mail", title: "E-posta"},
      {key: "title", title: "İş unvanı"},
      {key: "description", title: "Tanım"},
      {key: "activeDevices", title: "Aktif cihazlar"},
      {key: "groups", title: "Gruplar", hidden: false},
      {key: "department", title: "Departman", hidden: true},
      {key: "office", title: "Ofis", hidden: true},
      {key: "manager", title: "Manager", hidden: true},
      {key: "country", title: "Ülke", hidden: true},
      {key: "region", title: "Bölge", hidden: true},
      {key: "city", title: "Şehir", hidden: true},
      {key: "street", title: "Sokak", hidden: true},
      {key: "viberid", title: "ViberID", hidden: true},
      {key: "viberEnabled", title: "ViberBot etkin", hidden: true},
      {key: "telegramid", title: "TelegramID", hidden: true},
      {key: "telegramEnabled", title: "TelegramBot etkin", hidden: true},
      {key: "mattermostid", title: "MattermostID", hidden: true},
      {key: "mattermostEnabled", title: "MattermostBot etkin", hidden: true},
      {key: "authtypes", title: "İzin verilen kimlik doğrulama türleri", hidden: true, visfor: ["admins"]},
      {key: "lng", title: "Arayüz dili", hidden: true, visfor: ["admins"]},
      {key: "theme", title: "Arayüz teması", hidden: true, visfor: ["admins"]},
      {key: "compact", title: "Kompakt arayüz", hidden: true, visfor: ["admins"]},
      {key: "showDesktopIconsTitle", title: "Masaüstü simgelerinin başlıklarını göster", hidden: true, visfor: ["admins"]},
      {key: "awailApps", title: "Mevcut uygulamalar", visfor: ["admins"]},
      {key: "desktopApps", title: "Masaüstündeki uygulamalar", hidden: true, visfor: ["admins"]},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]},
      {key: "lastLogon", title: "Last Logon date", hidden: true, visfor: ["admins"]},
      {key: "lastIP", title: "Last IP address", hidden: true, visfor: ["admins"]},
      {key: "pwdLastSet", title: "PWD last set", hidden: true, visfor: ["admins"]},
      {key: "badPasswordTime", title: "Bad password time", hidden: true, visfor: ["admins"]},
      {key: "badPwdCount", title: "Bad password count", hidden: true, visfor: ["admins"]}
    ],
    devsheaders: [
      {key: "type", title: "Tip"},
      {key: "devicename", title: "Cihaz"},
      {key: "ip", title: "IP-adresi"}
    ]
  },
  api1c: {
    c1disabled: "API 1C modülü yönetici tarafından devre dışı bırakıldı",
    c1LinkIsNull: "Program ayarlarında 'API 1C URI' eksik",
    c1AuthIsNull: "Program ayarlarında 'API 1C muhasebe verilerini' eksik",
    accessDenied: "'API 1C (OData)' ye erişim yasaktır. Yanlış Muhasebe Verileri",
    userIsntAnAccouter: "Operasyona izin verilmez. 1C'ye erişimi olan bir gruba ait değilsiniz",
    doYouWantMarkTheseRecsAsCarriedOutIn1C: "1C muhasebe programında gerçekleştirildiği gibi bu kayıtları işaretlemek ister misiniz?",
    doYouWantMarkTheseRecsAsNotCarriedOutIn1C: "1C muhasebe programı yapıldıkları kayıtlardan işaretlemek ister misiniz?",
    theseRecsWillBeBlockedInPortal: "Kayıtlar portalda değiştirmek ve silmek için engellenecek",
    theseRecsWillBeUnblockedInPortal: "Portal'da değişim ve silme için kayıtların kilidi açılacak",
    selectedRecordsWereMarkedAsCarriedOutIn1C: "Seçilen kayıt setleri 1C Muhasebe Programında gerçekleştirildiği gibi işaretlendi",
    selectedRecordsWereUnmarkedAsCarriedOutIn1C: "1C muhasebe programındaki belge iletiminin bir işareti, seçilen kayıtlardan kaldırıldı"
  }
};
